import React from 'react';
import PropTypes from 'prop-types';
import Text from './Text';
import { css, StyleSheet } from 'aphrodite/no-important';
import { FONTS, MEDIA_QUERIES, WHITE, ALTO } from '../styles';
import Wrapper from './Wrapper';

const s = StyleSheet.create({
  root: {
    width: '100%',
    display: 'flex',
    height: 60,
    alignItems: 'center',
    ...FONTS.BOLD,
    borderBottom: `1px solid ${ALTO}`,
    fontSize: 18,
    backgroundColor: WHITE,

    [MEDIA_QUERIES.ON_DESKTOP]: {
      height: 90,
    },
  },
});

const PageTitle = ({ messageId }) => (
  <div className={css(s.root)}>
    <Wrapper>
      <Text messageId={messageId} />
    </Wrapper>
  </div>
);

PageTitle.propTypes = {
  messageId: PropTypes.string,
};

export default PageTitle;
